import React from "react";
import PropTypes from "prop-types";
import Step from "../../../../atoms/Wizard/Step";
import DragAndDropImages from "../../../../atoms/Forms/DragAndDropImages";

import styles from "./MainApp.organisms.Product.ProductSigleLoadWizard.ProductStep3.module.scss";
import i18n from "i18n";
export class ProdStepThree extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      file: null
    }
  }

  goBackFunc = () => {
    if(this.props.goBackFunc) this.props.goBackFunc(1)
  }

  render() {
    const { product, handleChangeImage, handleDelete, errors, files } = this.props;

    const stepContent = (
      <div className={styles["product-step-three-content"]}>
        <div className={styles["product-step-three-title"]} data-automation-id="input-image">
        {i18n.t("step.image.description")}
        </div>
        <DragAndDropImages
          name="image"
          handleChange={handleChangeImage}
          handleDelete={handleDelete}
          files={files}
          error={errors?.image}
          onHandleStarClick={this.props.onHandleStarClick}
          selectedStarIndex={this.props.selectedStarIndex}
          showSelectorFiles={true}
        />
      </div>
    );

    return (
      <div className={styles["product-step-three-container"]}>
        <Step title={i18n.t("step.image")} content={stepContent} goBackFunc={this.goBackFunc} ></Step>
      </div>
    );
  }
}

ProdStepThree.propTypes = {
  handleChange: PropTypes.func,
};

export default ProdStepThree;
